import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from './button';
import BasicSelect from './form-elements/basic-select';

interface Props {
  readonly page: number;
  readonly itemsPerPage: number;
  readonly totalItems: number;
  readonly onPageChange: (changePage: number) => void;
  readonly onRowsPerPageChange?: (change: number) => void;
}

type Direction = 'fwd' | 'back'

const perPageCounts = [
  { name: '25', id: '25' },
  { name: '50', id: '50' },
  { name: '75', id: '75' },
  { name: '100', id: '100' },
  { name: '250', id: '250' },
];

export default function PaginationIndicator({
  page, itemsPerPage, totalItems, onPageChange,
  onRowsPerPageChange,
}: Props) {
  const from = (page - 1) * itemsPerPage + 1;
  const to = page * itemsPerPage;
  const isLastPage = to >= totalItems;
  const isFirstPage = page === 1;

  const handleOnPageChange = (direction: Direction) => {
    let pageChange: number;

    if (direction === 'fwd') {
      pageChange = page + 1;
    } else {
      pageChange = page - 1;
    }

    onPageChange(pageChange);
  };

  const handlePerPageChange = (evt) => {
    const newPerPage = parseInt(evt.target.value, 10);
    onRowsPerPageChange!(newPerPage);
  };

  return (
    <Box paddingX={2} fontSize={12}>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        {onRowsPerPageChange && (
          <Box mr={2} display="flex" alignItems="center">
            <Typography variant="caption" mr={1}>Items per page: </Typography>
            <Box>
              <BasicSelect
                sx={{ height: 24 }}
                value={itemsPerPage}
                items={perPageCounts}
                onChange={handlePerPageChange}
              />
            </Box>
          </Box>
        )}
        <Typography variant="caption" mr={1}>
          {`${from} - ${isLastPage ? totalItems : to} of ${totalItems}`}
        </Typography>
        <Box>
          <Button
            data-testid="previous-page"
            icon={<ChevronLeftIcon />}
            onClick={() => handleOnPageChange('back')}
            disabled={isFirstPage}
          />
          <Button
            data-testid="next-page"
            icon={<ChevronRightIcon />}
            onClick={() => handleOnPageChange('fwd')}
            disabled={isLastPage}
          />
        </Box>
      </Box>
    </Box>
  );
}
